var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.5C10.5523 21.5 11 21.0523 11 20.5C11 19.9477 10.5523 19.5 10 19.5C9.44772 19.5 9 19.9477 9 20.5C9 21.0523 9.44772 21.5 10 21.5Z",
    stroke: "#F49600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.5C18.5523 21.5 19 21.0523 19 20.5C19 19.9477 18.5523 19.5 18 19.5C17.4477 19.5 17 19.9477 17 20.5C17 21.0523 17.4477 21.5 18 21.5Z",
    stroke: "#F49600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5H5.5L8.2 14.9C8.2935 15.3586 8.54485 15.7698 8.91028 16.0621C9.27572 16.3545 9.73211 16.5094 10.2 16.5H17.9C18.3679 16.5094 18.8243 16.3545 19.1897 16.0621C19.5552 15.7698 19.8065 15.3586 19.9 14.9L21.5 6.5H7.1",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesIcon);
export default __webpack_public_path__ + "static/media/QuotesIcon.bf2aaf41a42d1cd8dc840aac28efd6ec.svg";
export { ForwardRef as ReactComponent };